/**
 * @Description
 */
export default {
  meta: {
    title: '即插即踩-设置拍摄分析时段',
    url: '/passenger/settingPeriods', // 埋点字段，上报归属的模块
    urlName: '即插即踩' // 埋点字段，上报归属的模块
  }
};
